import _ from 'lodash';
const transformerFactory = ({ uiToApi = _.identity, apiToUi = _.identity, } = {}) => ({
    apiToUi: obj => {
        obj = _.cloneDeep(obj);
        const computed = Object.create(null);
        obj.__computed__ = computed;
        apiToUi(obj);
        return obj;
    },
    uiToApi: obj => {
        obj = _.cloneDeep(obj);
        uiToApi(obj);
        delete obj.__computed__;
        return obj;
    },
});
export default transformerFactory;
//# sourceMappingURL=transformerFactory.js.map